<template>
    <div class="container">
        <div class="upload_box">
            <div class="tab_box">
                <div v-if="boardAmericaType" :class="{active: active == 1 }" @click="active=1">北美材码单模板</div>
                <div v-if="boardZelkovaType" :class="{active: active == 2 }" @click="active=2">榉木码单模板</div>
                <div v-if="boardAfricaType" :class="{active: active == 3 }" @click="active=3">非洲材码单模板</div>
                <div v-if="categoryRawType" :class="{active: active == 4 }" @click="active=4">原木码单模板</div>
                <div v-if="nationalStandardType" :class="{active: active == 5 }" @click="active=5">国标/非洲材码单模板</div>
            </div>
            <div class="text-center relative">
                <el-upload class="upload-excel" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>导入上传码单</em></div>
                    <div class="el-upload__tip text-center" slot="tip">
                        只能上传excel文件<br/>
                        <el-link type="danger" @click="downTemplete" :underline="false" style="text-decoration: underline;">下载码单模板</el-link>
                    </div>
                </el-upload>
                <!-- <el-button class="funcPublicBtnChecked" style="position:relative;top:-40px;" @click="importFile"></el-button> -->
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .upload_box{
            width:820px; height:431px; background:rgba(255,255,255,1); box-shadow:0px 0px 10px rgba(0,0,0,0.16); opacity:1; border-radius:3px; padding: 9px 12px; position: absolute; top:50%; left: 50%; transform: translate(-50%, -50%);
            .tab_box{
                display: flex; align-items: center; border-bottom: 2px solid #EEEEEE; padding-bottom: 11px;
                & > div{
                    width: 150px; text-align: center; padding: 8px 0; border:1px solid #707070; border-radius:3px; cursor: pointer; font-size: 14px;
                    & + div{ margin-left: 30px; }
                    &.active{ background: #B21111; color: #fff; border:1px solid #B21111; }
                }
            }
            .upload-excel{
                background: #fff; padding: 80px 150px 65px;
                .el-icon-upload, .el-upload__text > em{ color: #B21111;text-decoration: underline;}
            }
        }
    }
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardZelkovaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                nationalStandardType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                active : "",
                upload_data : {},
                oss : {
                    host : "",
                },
                file_url : '',
                file:null,
                downloadName:"",
                downloadUCode:"",
                downloadUUrl:""
            }
        },
        created(){
            this.active = this.boardAmericaType?1: this.boardZelkovaType?2:this.boardAfricaType?5:this.categoryRawType?4:this.nationalStandardType?5:"";
            this.downloadName=this.boardAmericaType?"北美材码单模板":this.boardZelkovaType?"榉木码单模板":this.boardAfricaType?"非洲材码单模板":this.categoryRawType?"原木码单模板":this.nationalStandardType?"国标/非洲材码单模板":"";
            this.downloadUCode=this.boardAmericaType?"qc_america_stock":this.boardZelkovaType?"qc_zelkova_stock":this.boardAfricaType?"qc_africa_stock":this.categoryRawType?"qc_wood_stock":this.nationalStandardType?"qc_ds_stock":"";
            this.downloadUUrl=this.boardAmericaType?"/erp/import.qc.america":this.boardZelkovaType?"/erp/import.qc.zelkova":this.boardAfricaType?"/erp/import.qc.africa":this.categoryRawType?"/erp/import.qc.wood":this.nationalStandardType?"/erp/import.qc.ds":"";
        },
        methods:{
            handleSuccess(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                //this.tip('文件上传成功', 'success');
                this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            importFile(){
                this.analysis(this.downloadUUrl,this.file_url,"","","",response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
                // if(this.file_url!=" "){
                //     this.tip("请选择上传文件","warning")
                // }else{
                // }
			},
            downTemplete(){
                if(this.downloadName==""){
                    this.tip("请选择导入类型","warning")
                }else{
                    this.exportFile(this.downloadUCode,"","","",response=>{
                        const content = response.data;
                        const blob = new Blob([content], {type: response.headers['content-type']});
                        const fileName = this.downloadName+this.getDownloadTempleteTime(new Date())+'.xlsx';
                        if ('download' in document.createElement('a')) { // 非IE下载
                            const elink = document.createElement('a');
                            elink.download = fileName;
                            elink.style.display = 'none';
                            elink.href = URL.createObjectURL(blob);
                            document.body.appendChild(elink);
                            elink.click();
                            URL.revokeObjectURL(elink.href); // 释放URL 对象
                            document.body.removeChild(elink);
                        } else { // IE10+下载
                            navigator.msSaveBlob(blob, fileName);
                        }
                    })
                }
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        watch:{
            "active":function(val){
                if(val==1){
                    this.downloadName="北美材码单模板";
                    this.downloadUCode="qc_america_stock";
                    this.downloadUUrl="/erp/import.qc.america";
                }else if(val==2){
                    this.downloadName="榉木码单模板";
                    this.downloadUCode="qc_zelkova_stock";
                    this.downloadUUrl="/erp/import.qc.zelkova";
                }else if(val==3){
                    this.downloadName="非洲材码单模板";
                    this.downloadUCode="qc_africa_stock";
                    this.downloadUUrl="/erp/import.qc.africa";
                }else if(val==4){
                    this.downloadName="原木码单模板";
                    this.downloadUCode="qc_wood_stock";
                    this.downloadUUrl="/erp/import.qc.wood";
                }else if(val==5){
                    this.downloadName="国标/非洲材码单模板";
                    this.downloadUCode="qc_ds_stock";
                    this.downloadUUrl="/erp/import.qc.ds";
                }
            }
        }
    }
</script>
